import React from "react";
import "./Quotes.scss";
import quotationMark from "../../assets/quote.svg";

function Quotes({ quotesContent }) {
  return (
    <section className="quotes">
      <img
        src={quotationMark}
        className="quotes__mark"
        alt="opening quotation mark"
      />
      <div className="quotes__box">
        <p className="quotes__text">{quotesContent}</p>
      </div>
    </section>
  );
}

export default Quotes;
